import React from "react";
import "../styles/Section.css";

const services = [
  {
    title: "Custom Software Development",
    desc: "Tailored web and enterprise applications built using modern technologies."
  },
  {
    title: "Cloud Architecture",
    desc: "Scalable cloud infrastructure solutions for business growth."
  },
  {
    title: "AI & Automation",
    desc: "Intelligent automation systems to optimize operations and reduce costs."
  }
];

const Services = () => {
  return (
    <section id="services" className="section">
      <h2>Our Services</h2>
      <div className="cards">
        {services.map((service, index) => (
          <div key={index} className="card animate">
            <h3>{service.title}</h3>
            <p>{service.desc}</p>
            <button className="learn-btn">Learn More</button>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Services;